import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { ServiceProviderServices } from './ServiceProviderServices';

const ServiceProviderDndProviderComponent = ({
  schema,
  values,
  tableType,
  forcedValues,
  onChange,
}) => {
  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <ServiceProviderServices
          schema={schema}
          values={values}
          tableType={tableType}
          forcedValues={forcedValues}
          onChange={onChange}
        />
      </DndProvider>
    </>
  );
};

export default ServiceProviderDndProviderComponent;
